// @flow

import React, { type Node } from 'react';

type TeamsPricingProps = {
  children: ({ price: string, isAnnual: boolean }) => Node,
  price: string,
  isAnnual: boolean,
  interval: string,
};

const TeamsPricing = ({ children, price, isAnnual }: TeamsPricingProps) =>
  children({ price, isAnnual });

TeamsPricing.defaultProps = {
  children: ({ price, isAnnual }) => (
    <span>{`${price}/mo ${isAnnual ? '(paid annually)' : ''}`.trim()}</span>
  ),
};

export default TeamsPricing;
